import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "@reduxjs/toolkit";
import sidebarReducer from "./slices/sidebarSlice";
import recipeReducer from "./slices/recipeSlice";
import siteReducer from "./slices/siteSlice";
import recipeUsageReducer from "./slices/recipeUsageSlice";
import plantedAcresReducer from "./slices/plantedAcresSlice";
import globalReducer from "./slices/globalSlice";
import siteFilterReducer from "./slices/siteFilterSlice";
import plantedAcresFilterReducer from "./slices/plantedAcresFilterSlice";

const rootReducer = combineReducers({
  sidebar: sidebarReducer,
  recipe: recipeReducer,
  site: siteReducer,
  siteFilter: siteFilterReducer,
  plantedAcresFilter: plantedAcresFilterReducer,
  recipeUsage: recipeUsageReducer,
  plantedAcres: plantedAcresReducer,
  global: globalReducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "sidebar",
    "site",
    "plantedAcres",
    "global",
    "siteFilter",
    "plantedAcresFilter",
  ],
};

// Persist the reducers that are required
const persistedRootReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedRootReducer,
  // middleware to handle redux-persist serialization
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

export const persistor = persistStore(store);
export default store;
